import { render } from "./BuildIcon3.vue?vue&type=template&id=7ca92f8b&scoped=true"
import script from "./BuildIcon3.vue?vue&type=script&lang=js"
export * from "./BuildIcon3.vue?vue&type=script&lang=js"

import "./BuildIcon3.vue?vue&type=style&index=0&id=7ca92f8b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca92f8b"]])

export default __exports__